const heroStackContainer = (theme) => ({
  gap: '2.5rem',
  height: '100%',
  width: '100%',
  background: `linear-gradient(180deg, ${theme.palette.contrast.A700} 0%, #000000 100%)`,
  padding: { xs: '6rem 2rem 6rem 2rem', md: '10rem 1.5rem 5rem 1.5rem' },
});

const titleTypography = {
  color: 'white',
  width: { xs: '100%', ipad: '70%' },
  fontSize: { xs: '2.5rem', md: '4rem' },
};

const subtitleTypography = {
  color: 'white',
  fontWeight: 500,
  textAlign: 'center',
  whiteSpace: 'pre-line',
};

const heroButtonsStack = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  gap: '1.5rem',
};

const imageStack = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  maxWidth: '70rem',
  padding: { xs: '0 1.5rem', md: '0' },
};

const entitiesContainer = {
  gap: '3rem',
  padding: '0 1.5rem 2rem 1.5rem',
  width: '90%',
};

const entitiesImagesListItem = (bigImage, lastImage) => ({
  maxHeight: bigImage ? '4.5rem' : '3.18rem',
  height: bigImage ? '4.5rem' : { xs: '2rem', md: '3.18rem' },
  objectFit: 'contain',
  marginRight: lastImage ? '10rem' : '0',
});

const entitiesSubContainer = {
  maxWidth: '80rem',
  width: '100%',
  gap: '2.5rem',
};

export {
  heroStackContainer,
  titleTypography,
  subtitleTypography,
  heroButtonsStack,
  imageStack,
  entitiesContainer,
  entitiesImagesListItem,
  entitiesSubContainer,
};
